// src/services/api.js (Versión Final con baseURL para Dominio)
import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'http://216.119.151.132:4000/api', // <-- Volvemos a esta URL 
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor que añade el token a cada petición segura.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- Endpoints de Auth ---
export const apiLogin = (username, password) => {
  return apiClient.post('/auth/login', { username, password });
};

export const apiRegister = (userData) => {
  return apiClient.post('/auth/register', userData);
};

// --- Endpoints de StreetRanges ---
export const getStreetRanges = () => apiClient.get('/streetranges');
export const createStreetRange = (rangeData) => apiClient.post('/streetranges', rangeData);
export const updateStreetRange = (rangeId, rangeData) => apiClient.put(`/streetranges/${rangeId}`, rangeData);
export const deleteStreetRange = (rangeId) => apiClient.delete(`/streetranges/${rangeId}`);
export const uploadStreetRangesCSV = (file) => {
  const formData = new FormData();
  formData.append('csvFile', file);
  return apiClient.post('/streetranges/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// --- Endpoints de Firms ---
export const getFirms = () => apiClient.get('/firms');
export const createFirm = (firmData) => apiClient.post('/firms', firmData);
export const updateFirm = (firmId, firmData) => apiClient.put(`/firms/${firmId}`, firmData);
export const deleteFirm = (firmId) => apiClient.delete(`/firms/${firmId}`);
export const uploadFirmsCSV = (file) => {
  const formData = new FormData();
  formData.append('csvFile', file);
  return apiClient.post('/firms/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// --- Búsqueda ---
export const apiSearchAddress = (address) => {
  return apiClient.post('/search', { address });
};

export default apiClient;
